import React from 'react';
import styled from '@emotion/styled';
import { Spinner } from '@zapier/design-system';

export function PageLoadingSpinner() {
  return (
    <SpinnerContainer>
      <Spinner size="large" />
    </SpinnerContainer>
  );
}

const SpinnerContainer = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
